import { render, staticRenderFns } from "./MonitoringShow.vue?vue&type=template&id=6704b701&scoped=true"
import script from "./MonitoringShow.vue?vue&type=script&lang=js"
export * from "./MonitoringShow.vue?vue&type=script&lang=js"
import style0 from "./MonitoringShow.vue?vue&type=style&index=0&id=6704b701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704b701",
  null
  
)

export default component.exports